import {decodeAccessToken} from '@resurs-internal/core/lib/jwt';
import {RestClient} from '../services/rest-client';
import useConfig from './useConfig';

// Refresh this far ahead of expiry - inside the token issuer's own clock-skew
// allowance, so a refresh triggered here is never itself rejected as "not yet
// valid" by a slightly-behind server clock.
const REFRESH_MARGIN_MILLIS = 45_000;

export const useBankIDClient = (
  sessionToken?: string | undefined | null,
  refreshSessionToken?: () => Promise<string | undefined>,
) => {
  const config = useConfig();

  return new RestClient({
    enableLog: config.enableLog,
    apiKey: config.apiKey,
    createAuthHeader: async () => {
      if (!sessionToken) return '';
      const {exp, iat} = decodeAccessToken(sessionToken) ?? {};
      // eslint-disable-next-line react-hooks/purity
      const skew = Date.now() - (iat ?? 0) * 1000;
      // eslint-disable-next-line react-hooks/purity
      const expiresInMillis = (exp ?? 0) * 1000 - skew - Date.now();
      if (refreshSessionToken && expiresInMillis < REFRESH_MARGIN_MILLIS) {
        const refreshed = await refreshSessionToken().catch(() => undefined);
        if (refreshed) return `Bearer ${refreshed}`;
      }
      return `Bearer ${sessionToken}`;
    },
    refreshAuth: async () => {
      await refreshSessionToken?.();
    },
  });
};
